const darkColors = {
    rosewater: "#f5e0dc",
    flamingo: "#f2cdcd",
    pink: "#f5c2e7",
    mauve: "#cba6f7",
    red: "#f38ba8",
    maroon: "#eba0ac",
    peach: "#fab387",
    yellow: "#f9e2af",
    green: "#a6e3a1",
    teal: "#94e2d5",
    sky: "#89dceb",
    sapphire: "#74c7ec",
    blue: "#89b4fa",
    lavender: "#b4befe",
    text: "#cdd6f4",
    subtext1: "#bac2de",
    subtext0: "#a6adc8",
    overlay2: "#9399b2",
    overlay1: "#7f849c",
    overlay0: "#6c7086",
    surface2: "#585b70",
    surface1: "#45475a",
    surface0: "#313244",
    base: "#1e1e2e",
    mantle: "#181825",
    crust: "#11111b",
};

const lightColors = {
    rosewater: "#DC8A78",
    flamingo: "#DD7878",
    pink: "#EA76CB",
    mauve: "#8839EF",
    red: "#D20F39",
    maroon: "#E64553",
    peach: "#FE640B",
    yellow: "#DF8E1D",
    green: "#40A02B",
    teal: "#179299",
    sky: "#04A5E5",
    sapphire: "#209FB5",
    blue: "#1E66F5",
    lavender: "#7287FD",
    text: "#4C4F69",
    subtext1: "#5C5F77",
    subtext0: "#6C6F85",
    overlay2: "#7C7F93",
    overlay1: "#8C8FA1",
    overlay0: "#9CA0B0",
    surface2: "#ACB0BE",
    surface1: "#BCC0CC",
    surface0: "#CCD0DA",
    base: "#EFF1F5",
    mantle: "#E6E9EF",
    crust: "#DCE0E8",
};

const latte = {
    dark: false,
    colors: {
        "background": lightColors.crust,
        "surface": lightColors.base,
        "primary": lightColors.mauve,
        "secondary": lightColors.peach,
        "error": lightColors.red,
        "info": lightColors.sky,
        "success": lightColors.green,
        "warning": lightColors.yellow,
        "on-surface": lightColors.text,
        "on-background": lightColors.text,
    },
};
const mocha = {
    dark: true,
    colors: {
        "background": darkColors.base,
        "surface": darkColors.surface0,
        "primary": darkColors.mauve,
        "secondary": darkColors.peach,
        "error": darkColors.red,
        "info": darkColors.sky,
        "success": darkColors.green,
        "warning": darkColors.yellow,
        "on-surface": darkColors.text,
        "on-background": darkColors.text,
    },
};

export default {
    latte,
    mocha,
};
